/** @format */

import React, { useCallback } from "react";
import { UserResponse } from "../../app/services/userApi";

type Props = {
  user?: UserResponse;
};

const UserAvatar: React.FC<Props> = ({ user }) => {
  const getAvatarSrc = useCallback(() => {
    let src;

    switch (user?.role) {
      case "wjec":
        src = user.meta?.avatar;
        break;

      case "teacher":
        const firstName = user.meta.hwb?.given_name ?? "unknown";
        const lastName = user.meta.hwb?.family_name ?? "unknown";
        src = `https://ui-avatars.com/api/?name=${firstName}+${lastName}&background=random&rounded=true&bold=true&font-size=0.5`;
        break;
    }

    return src ?? "https://gravatar.com/avatar?d=mp&s=30";
  }, [user]);

  return (
    <img
      className="rounded-circle border-1 border bg-primary user-image"
      style={{
        width: 40,
        height: 40,
      }}
      src={getAvatarSrc()}
      alt={`${user?.meta.name ?? "Unknown User"}`}
    />
  );
};

export default UserAvatar;
